export class Shimmer2 {
	constructor(e) {
		this.el = e;
		this.classes = [];
		this.classes[-1] = this.el.getAttribute(`data-aboveclass`);
		this.classes[0] = this.el.getAttribute(`data-onclass`);
		this.classes[1] = this.el.getAttribute(`data-belowclass`);

		document.addEventListener(`scroll`, evt=>{
			this.apply();
		}, { passive: true });
		document.addEventListener(`resize`, evt=>{
			this.apply();
		}, { passive: true });
		this._position = false;
		this.apply();
	}

	apply() {
		let p = this.position();
		if (p===this._position) return;
		console.log(`Shimmer2 applying...`);
		this._position = p;
		for (let i=-1; i<=1; i++) {
			if (p===i) {
				this.el.classList.add(this.classes[i]);
			} else {
				this.el.classList.remove(this.classes[i]);
			}
		}
	}

	// position returns -1 if we are 'above' the element (ie scrolling down, the element is still to come),
	// 0 if we are 'on' the element,
	// and 1 if we are 'below' the element (ie we have scrolled past the element)
	position() {
		let midline = window.scrollY + top.innerHeight/2;
		let delta = top.innerHeight/4;
		let r = this.el.getBoundingClientRect();
		let elTop = window.scrollY + r.top;
		let elBottom = elTop + r.height;

		if (elTop > midline + delta) {
			return -1;
		}
		if (elBottom < midline-delta) {
			return 1;
		}
		return 0;	// we are 'on' the element
	}
	static init() {
		for (let e of document.querySelectorAll(`[data-instance="Shimmer2"]`)) {
			new Shimmer2(e);
		}
	}
}